<template>
	<div>
		<div class="box">
			<div class="nav">
				<el-menu
					:default-active="activeIndex" 
					background-color="#fff"
					text-color="#666"
					mode="horizontal"
					active-text-color="#b5060d"
					@select="handleSelect">
					<template
						v-for="(item, index) in items" >
							<el-menu-item v-if="!item.hidden" :index="getString(index)">{{ item.meta.title }}</el-menu-item>
					</template>
				</el-menu>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import Lockr from 'lockr'

	export default {
		name: 'Sidebar',
		props: {
			mainRouter: {
				type: String,
				default: ''
			},
			addOffset: {
				type: Number,
				default: 70
			},
			/** 选择项目 */
			items: {
				type: Array,
				default: () => {
					return [
						
					]
				}
			},
			activeIndex: {
				type: [String,Number],
				default: ''
			}
		},
		data() {
			return {
				// activeIndex:'0'
			}
		},
		computed: {
			
		},
		watch: {
			
		},
		mounted() {},
		methods: {
			handleSelect(key){
				// this.activeIndex = key
				// this.$router.push(this.items[key].path)
				this.$emit("nav-select",key)
			},
			
			getString(index){
				return `${index}`
			}
		}
	}
</script>

<style lang="scss" scoped>
	.box {
		width: 1200px;
		margin-top: 10px;
	}
	
	.nav {
		margin-top: 0px;
		background-color: #fff;
		height: 45px;
		display: flex;
		/* justify-content: space-around; */
		// align-items: center;
	}
	
	.nav_item {
		color: #545454;
		font-weight: 600;
		/* padding: 0 40px; */
	}
	
	/deep/ .el-menu--horizontal > .el-menu-item.is-active {
	    background-color: #b5060d !important;
	    color: #fff !important;
	}
	/deep/ .el-menu--horizontal > .el-menu-item {
	    height: 45px;
	    line-height: 45px;
	}
	
</style>
